var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTonDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0526 12.5H13.9477C12.4577 12.5 11.5133 14.1073 12.2629 15.4066L17.2643 24.0755C17.5907 24.6415 18.4086 24.6415 18.7349 24.0755L23.7374 15.4066C24.486 14.1093 23.5416 12.5 22.0526 12.5ZM17.2592 13.9808V21.4738L16.171 19.3678L13.5428 14.6672C13.3694 14.3664 13.5836 13.9808 13.9467 13.9808H17.2592ZM22.4544 14.6662L19.8272 19.3688L18.738 21.4758V13.9798H22.0505C22.4136 13.9798 22.6277 14.3653 22.4544 14.6662Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36H36V0H18ZM18 32C25.732 32 32 25.732 32 18C32 10.268 25.732 4 18 4C10.268 4 4 10.268 4 18C4 25.732 10.268 32 18 32Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonDecor);
export default __webpack_public_path__ + "static/media/ton_decor.82875e2f6014468d9df5b7ec65e89630.svg";
export { ForwardRef as ReactComponent };